import { useTranslation } from 'react-i18next';

const ReservationFilter = ({ filterReservations, setCurrentFilter, currentFilter }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap justify-center sm:justify-between gap-x-2 gap-y-3 items-center px-[8vw] md:px-16 lg:px-[10vw] py-4 bg-white shadow-lg rounded-b-lg border-b-2">
      <button
        onClick={() => {
          filterReservations('all');
          setCurrentFilter('all');
        }}
        className={`px-4 py-2 text-sm font-semibold rounded-full transition-all duration-300 ${
          currentFilter === 'all'
            ? 'bg-[#2E7A32] text-white border-b border-r border-green-900 shadow'
            : 'bg-gray-300 hover:bg-gray-400 hover:border-gray-500 text-black border-b border-r border-gray-400'
        }`}
      >
        {t('farmshare.userReservations.statusFilter.all')}
      </button>

      <button
        onClick={() => {
          filterReservations('pending');
          setCurrentFilter('pending');
        }}
        className={`px-4 py-2 text-sm font-semibold rounded-full transition-all duration-300 ${
          currentFilter === 'pending'
            ? 'bg-[#2E7A32] text-white border-b border-r border-green-900 shadow'
            : 'bg-gray-300 hover:bg-gray-400 hover:border-gray-500 text-black border-b border-r border-gray-400'
        }`}
      >
        {t('farmshare.userReservations.statusFilter.pending')}
      </button>

      <button
        onClick={() => {
          filterReservations('approved');
          setCurrentFilter('approved');
        }}
        className={`px-4 py-2 text-sm font-semibold rounded-full transition-all duration-300 ${
          currentFilter === 'approved'
            ? 'bg-[#2E7A32] text-white border-b border-r border-green-900 shadow'
            : 'bg-gray-300 hover:bg-gray-400 hover:border-gray-500 text-black border-b border-r border-gray-400'
        }`}
      >
        {t('farmshare.userReservations.statusFilter.approved')}
      </button>

      <button
        onClick={() => {
          filterReservations('in-use');
          setCurrentFilter('in-use');
        }}
        className={`px-4 py-2 text-sm font-semibold rounded-full transition-all duration-300 ${
          currentFilter === 'in-use'
            ? 'bg-[#2E7A32] text-white border-b border-r border-green-900 shadow'
            : 'bg-gray-300 hover:bg-gray-400 hover:border-gray-500 text-black border-b border-r border-gray-400'
        }`}
      >
        {t('farmshare.userReservations.statusFilter.inUse')}
      </button>

      <button
        onClick={() => {
          filterReservations('filled');
          setCurrentFilter('filled');
        }}
        className={`px-4 py-2 text-sm font-semibold rounded-full transition-all duration-300 ${
          currentFilter === 'filled'
            ? 'bg-[#2E7A32] text-white border-b border-r border-green-900 shadow'
            : 'bg-gray-300 hover:bg-gray-400 hover:border-gray-500 text-black border-b border-r border-gray-400'
        }`}
      >
        {t('farmshare.userReservations.statusFilter.toReview')}
      </button>

      <button
        onClick={() => {
          filterReservations('returned');
          setCurrentFilter('returned');
        }}
        className={`px-4 py-2 text-sm font-semibold rounded-full transition-all duration-300 ${
          currentFilter === 'returned'
            ? 'bg-[#2E7A32] text-white border-b border-r border-green-900 shadow'
            : 'bg-gray-300 hover:bg-gray-400 hover:border-gray-500 text-black border-b border-r border-gray-400'
        }`}
      >
        {t('farmshare.userReservations.statusFilter.returned')}
      </button>

      <button
        onClick={() => {
          filterReservations('canceled');
          setCurrentFilter('canceled');
        }}
        className={`px-4 py-2 text-sm font-semibold rounded-full transition-all duration-300 ${
          currentFilter === 'canceled'
            ? 'bg-[#2E7A32] text-white border-b border-r border-green-900 shadow'
            : 'bg-gray-300 hover:bg-gray-400 hover:border-gray-500 text-black border-b border-r border-gray-400'
        }`}
      >
        {t('farmshare.userReservations.statusFilter.canceled')}
      </button>

      <button
        onClick={() => {
          filterReservations('archived');
          setCurrentFilter('archived');
        }}
        className={`px-4 py-2 text-sm font-semibold rounded-full transition-all duration-300 ${
          currentFilter === 'archived'
            ? 'bg-[#2E7A32] text-white border-b border-r border-green-900 shadow'
            : 'bg-gray-300 hover:bg-gray-400 hover:border-gray-500 text-black border-b border-r border-gray-400'
        }`}
      >
        {t('farmshare.userReservations.statusFilter.archived')}
      </button>
    </div>
  );
};

export { ReservationFilter };
